module.exports = __webpack_public_path__ + "static/media/upload.154306d8.svg";